// import * as queryString from 'query-string';

/* eslint no-param-reassign: ["error", { "props": false }] */
import urljoin from 'url-join';
import srcset from 'srcset';
import Router from 'next/router';

import config, { appHost } from '../config';

export function urlIsAbsolute(url) {
    const regex = /^https?:\/\//;
    const startsWithHttpOrHttps = regex.test(url);
    return startsWithHttpOrHttps;
}

export function formatUrlForCdn(url) {
    if (!urlIsAbsolute(url)) {
        const regex = /^\/v(0?[1-9]|[1-9][0-9])\//;

        if (regex.test(url)) {
            return urljoin(config.cdnUrl, url);
        }

        const path = `/${process.env.MARKETING_ASSETS_PATH}${url}`;
        return urljoin(config.staticCdnUrl, path);
    }
    return url;
}

export function updateSrcSetForCdn(srcSet) {
    const parsedSrcSet = srcset.parse(srcSet);
    parsedSrcSet.forEach((src) => {
        src.url = formatUrlForCdn(src.url);
    });
    return srcset.stringify(parsedSrcSet);
}
// export function parseUrlParam(url, param) {
//     const parsed = queryString.parse(url);
//     if (param in parsed) {
//         return parsed[param];
//     }
//     return '';
// }

export const prismicRedirect = (url) => {
    console.log('prismicRedirect', url);
    if (url.startsWith('http')) {
        // external urls, like support page
        window.location = url;
    } else if (url.startsWith('app:')) {
        // links pointing to the utr app
        window.location = url.replace('app:', appHost);
    } else {
        // internal routing within marketing app
        Router.push(url);
    }
};

export function isAppUrl(url) {
    return url.startsWith('app:');
}

export function isInternalRouteUrl(url) {
    return !urlIsAbsolute(url) && !isAppUrl(url);
}

export function formatPrismicUrl(url) {
    if (isAppUrl(url)) {
        return url.replace('app:', appHost);
    }

    return url;
}

export function getTarget(url) {
    if (urlIsAbsolute(url)) {
        return '_blank';
    }

    return null;
}
